export const PINNED_FOOTER_ID = 'pinned-footer-id';
export const PINNED_CONTAINER_ID = 'ht-pinned-container';
